const inspector = {
  "Admin": {
    actions: ['view']
  },
  "Content": {
    actions: ['view']
  },
  "Dashboard": {
    actions: ['view']
  },
  "Help": {
    actions: ['view']
  },
  "Inbox": {
    actions: ['view']
  },
  "Tasks": {
    actions: ['view']
  },
  "Notifications": {
    actions: ['view']
  },
  "Objects": {
    actions: []
  },
  "Search": {
    actions: []
  },
  "Settings": {
    actions: ['view']
  },
  "Support": {
    actions: ['view']
  },
  "Teams": {
    actions: []
  },
  "Profile.PersonalInformation": {
    actions: ['view', 'edit']
  },
  "Profile.Password": {
    actions: ['view', 'edit']
  },
  "Profile.Notifications": {
    actions: []
  },
  "Profile.Security": {
    actions: []
  },
  "Profile.Log": {
    actions: []
  },
  "Modules.Customer": {
    actions: ['view', 'edit', 'create', 'delete']
  },
  "Modules.Customer.Contacts": {
    actions: ['view', 'edit', 'create', 'delete']
  },
  "Modules.Customer.Comments": {
    actions: ['view', 'edit', 'create', 'delete']
  },
  "Modules.Customer.Responsibles": {
    actions: ['view', 'edit', 'create', 'delete']
  },
  "Modules.Customer.Address": {
    actions: ['view', 'edit', 'create', 'delete']
  },
  "Modules.Customer.Station": {
    actions: ['view', 'edit', 'create', 'delete']
  },
  "Modules.Customer.TechnicalInformation": {
    actions: ['view', 'edit', 'create', 'delete']
  },
  "Modules.Gps": {
    actions: ['view', 'edit', 'create', 'delete']
  },
  "Modules.Inspection": {
    actions: ['view', 'edit', 'edit:own', 'create', 'delete', 'delete:own']
  },
  "Modules.PeriodicCheck": {
    actions: ['view', 'edit', 'create', 'delete']
  },
  "Modules.Responsible": {
    actions: ['view', 'edit', 'create', 'delete']
  },
  'Modules.Responsible.Comments': {
    actions: ['view', 'edit', 'create']
  },
  'Modules.Responsible.Contacts': {
    actions: ['view', 'edit', 'create']
  },
  'Modules.Responsible.Information': {
    actions: ['view', 'edit', 'create']
  },
  'Modules.Support': {
    actions: ['view', 'edit', 'create']
  },
  'MainMenu.Home': {
    actions: ['view']
  },
  'MainMenu.WorkManagement': {
    actions: ['view']
  },
  'MainMenu.Notifications': {
    actions: ['view']
  },
  'MainMenu.Inbox': {
    actions: ['view']
  },
  'MainMenu.Tasks': {
    actions: ['view']
  },
  'MainMenu.Support': {
    actions: ['view']
  },
  'SubMenu.Help': {
    actions: ['view']
  },
  'SubMenu.Search': {
    actions: ['view']
  },
  'ProfileMenu.MyProfile': {
    actions: ['view']
  },
  'ProfileMenu.Admin': {
    actions: ['view']
  },
  'ProfileMenu.Content': {
    actions: ['view']
  },
  'ProfileMenu.Objects': {
    actions: ['view']
  },
  'ProfileMenu.Teams': {
    actions: ['view']
  },
  'ProfileMenu.SignOut': {
    actions: ['view']
  },
  'AdminMenu.General': {
    actions: ['view']
  },
  'AdminMenu.Customization': {
    actions: ['view']
  },
  'AdminMenu.User': {
    actions: ['view']
  },
  'AdminMenu.Security': {
    actions: ['view']
  },
  'AdminMenu.Permissions': {
    actions: ['view']
  },
  'AdminMenu.Database': {
    actions: ['view']
  },
  'AdminMenu.Reports': {
    actions: ['view']
  },
  'AdminMenu.Enargas': {
    actions: ['view']
  },
}

export default inspector